module.exports = __webpack_public_path__ + "static/apple-icon-180x180-867b37702d242cff351f045145431b9a.png";